module.exports = __webpack_public_path__ + "img/em4.87c259a2.jpg";